import { render, staticRenderFns } from "./base-alerts.vue?vue&type=template&id=73e044aa&scoped=true"
import script from "./base-alerts.vue?vue&type=script&lang=js"
export * from "./base-alerts.vue?vue&type=script&lang=js"
import style0 from "./base-alerts.vue?vue&type=style&index=0&id=73e044aa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e044aa",
  null
  
)

export default component.exports